module.exports = __webpack_public_path__ + "static/Theinhardt-Light-4b966d07fa3d6360864dcf428dfe0d0c.woff2";